/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import styled from 'styled-components';
import * as constants from '@veeam/components/lib/helpers/constants';
import { colors } from '@veeam/components/lib/themes/colors/colors';

export const AllButtonWrapper = styled.div`
  display: flex;
  margin-left: ${constants.SPACING_M};
  padding-left: ${constants.SPACING_M};
  border-left: ${constants.BASE_BORDER_WIDTH} solid ${colors.G300};
`;
